import { render, staticRenderFns } from "./AddCustomerModal.vue?vue&type=template&id=35bd08ea&scoped=true"
import script from "./AddCustomerModal.vue?vue&type=script&lang=js"
export * from "./AddCustomerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bd08ea",
  null
  
)

export default component.exports